<template>
    <div class="modal fade" id="appMgrManagedConfigurationModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv">
                        <div class="modal-header-text-scv">
                            アプリケーション管理設定
                        </div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="modal-body-text-area-scv" style="margin-bottom: 16px;">
                        <template v-if="!readonly">
                            設定する項目にチェックを入れてください。
                        </template>
                        <template v-else>
                            アプリケーション管理設定について、以下の設定が行われています。
                        </template>
                    </div>
                    <div class="app-mgr-managed-conf-table">
                        <template v-if="show">
                            <div style="margin: 0px 16px;">
                                <AppMgrManagedConfiguration ref="configuration" :readonly="readonly" :list="list" :listSetting="listSetting" @showBundleArrayModal="showBundleArrayModal" />
                            </div>
                        </template>
                    </div>
                    <template v-if="!readonly">
                        <button @click="onReset" type="button" class="btn-scv-lightblue-small" style="margin-top: 8px; width : 144px">初期設定に戻す</button>
                    </template>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <template v-if="!readonly">
                                <button type="button" class="btn-scv-blue" @click="onOK">OK</button>
                                <button type="button" class="btn-scv-white" data-bs-dismiss="modal" style="margin-left: 40px;">キャンセル</button>
                            </template>
                            <template v-else>
                                <button type="button" class="btn-scv-white" data-bs-dismiss="modal">閉じる</button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AppMgrManagedConfigurationBundleArrayModal ref="bundleArrayModal"
                                                @onOK="onBundleArrayModalOK" />
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { cloneDeep } from 'lodash';
    import $ from "jquery";
    import AppMgrManagedConfiguration from '@/components/Mobile/AndroidAppDist/AppMgrManagedConfiguration.vue'
    import { LoadingUtil } from '@/util/LoadingUtil'
    import AppMgrManagedConfigurationBundleArrayModal from '@/components/Mobile/AndroidAppDist/AppMgrManagedConfigurationBundleArrayModal.vue';
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        props: {
            readonly: { type: Boolean, default: false },  // 読み取り専用

            /* list と listSettingは長さは一致しなくてもいい */
            list: { type: Array, required: true },  // 管理設定情報一覧（Array<schema.AMAPI_ManagedProperty>）
            listSetting: { type: Object, required: true },  // 設定が有効なデータ（{ [key: string]: any }）
        },
        components: {
            AppMgrManagedConfiguration,
            AppMgrManagedConfigurationBundleArrayModal,
        },
        emits: [
            /*
             * OKボタン押下
             * @param[in] { [key: string]: any } : 設定が有効なデータ(cloneDeep済み)
             */
            'onOK'
        ],
    })

    export default class AppMgrManagedConfigurationModal extends Vue {
        // 発行済みID
        private static modalIDNumber = 0;
        // 自身のID
        private myModalIDNumber = 0;

        // 表示中かどうか(開いたタイミングでmountedが走るようにv-ifで表示/非表示を管理する)
        private show = false;

        // BundelArrayModalについて
        // 本当はAppMgrManagedConfigurationの中にAppMgrManagedConfigurationBundleArrayModalを置きたかったが、
        // AppMgrManagedConfigurationBundleArrayModalの中でAppMgrManagedConfigurationを呼び出しており、この辺りの再帰呼び出しが上手くいかなかった。
        // なので、このファイルにAppMgrManagedConfigurationBundleArrayModalを用意し、呼び出したいタイミングでemitしてもらうこととする

        /**
         * @brief   created
         */
        public created(): void {
            // 発行済みIDをインクリメントして他のメッセージダイアログとIDが重複しないようにする
            AppMgrManagedConfigurationModal.modalIDNumber += 1;
            this.myModalIDNumber = AppMgrManagedConfigurationModal.modalIDNumber;
        }

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            $('#appMgrManagedConfigurationModal').attr('id', "appMgrManagedConfigurationModal" + this.myModalIDNumber);

            const el = document.getElementById("appMgrManagedConfigurationModal" + this.myModalIDNumber);
            if(null != el) {
                // 画面が開いた時の処理
                el.addEventListener('show.bs.modal', () => {
                    LoadingUtil.Start();
                    // ローディング画面を出すために少しあとでshowする
                    window.setTimeout(() => {
                        this.show = true;
                    }, 0);
                });

                el.addEventListener('shown.bs.modal', () => {
                    LoadingUtil.Stop();
                });

                // 画面が閉じた時の処理
                el.addEventListener('hide.bs.modal', () => {
                    this.show = false;
                });
            }

            // BUNDLE_ARRAYの追加モーダル
            const refObj: any = this.$refs;
            if (undefined != refObj.bundleArrayModal) {
                const el = document.getElementById(refObj.bundleArrayModal.GetID());
                if(null != el) {
                    el.addEventListener('hidden.bs.modal', function (e) {
                        // 子モーダルダイアログを閉じた後に元のモーダルダイアログでスクロールができなくなる問題の対処
                        $('body').addClass('modal-open');
                    });
                }
            }
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return 'appMgrManagedConfigurationModal' + this.myModalIDNumber;
        }
        
        /**
         * @brief	OKボタン
         */
        private onOK(): void {
            // 設定を画面から取得
            const refObj: any = this.$refs;
            this.$emit('onOK', cloneDeep(refObj.configuration.getSetting()));
            BootstrapUtil.hideModal("appMgrManagedConfigurationModal" + this.myModalIDNumber);
        }

        /**
         * @brief	初期設定に戻す
         */
        private onReset(): void {
            // 設定に通知
            const refObj: any = this.$refs;
            refObj.configuration.onReset();
        }

        /*
         * Bundle_Arrayの追加画面の表示要求
         * @param[in] 表示内容：Array<schema.AMAPI_ManagedProperty>
         * @param[in] 設定内容：{ [key: string]: any }
         * @param[in] Bundle_Arrayのキー名：string
         * @param[in] true(追加) false(編集)：boolean
         */
        private showBundleArrayModal(list: Array<schema.AMAPI_ManagedProperty>, listSetting: { [key: string]: any }, bundleArrayKey: string, bAddMode: boolean): void {
            const refObj: any = this.$refs;
            if (undefined == refObj.bundleArrayModal) {
                return;
            }

            // Bundle_Array追加画面表示
            refObj.bundleArrayModal.Set(list, listSetting, bundleArrayKey, bAddMode);
            BootstrapUtil.showModal(refObj.bundleArrayModal.GetID());
        }

        /*
         * Bundle_Arrayの追加画面の表示要求
         * @param[in] 表示内容：Array<schema.AMAPI_ManagedProperty>
         * @param[in] 設定内容：{ [key: string]: any }
         * @param[in] Bundle_Arrayのキー名：string
         * @param[in] true(追加) false(編集)：boolean
         */
        private onBundleArrayModalOK(settings: { [key: string]: any }, key: string, addMode: boolean): void {
            // 設定に通知
            const refObj: any = this.$refs;
            refObj.configuration.onBundleArrayModalOK(settings, key, addMode);
        }
    }
</script>

<style scoped>
    .app-mgr-managed-conf-table {
        border-style: solid;
        border-width: 1px;
        border-color: #cdd7eb;
        overflow: auto;
        min-height: 240px;
        max-height: 600px;  /* モーダルの最大高さに合わされて実際は510pxくらいになる */
        width: 928px;
    }
</style>
